import { styled } from '@/stitches.config';
import { Box } from '@base-app';

import { ReactComponent as CollectionBlood } from '@assets/icons/collection-blood-drop.svg';
import { ReactComponent as CollectionBuccal } from '@assets/icons/collection-buccal.svg';
import { ReactComponent as CollectionSaliva } from '@assets/icons/collection-saliva.svg';

const iconSize = 56;

export const StyledSamplesInfoByType = styled(Box, {
  display: 'flex',
  flex: '1 0 300px',
  flexDirection: 'column',
});

export const StyledSamplesInfoByTypeContent = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
});

export const StyledSampleTypesList = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginRight: '$8',
  flex: '0 0 150px',
  minHeight: '120px',
});

export const StyledSampleTypeContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  marginBottom: '$4',
});

export const CollectionBloodIcon = styled(CollectionBlood, {});

export const CollectionBuccalIcon = styled(CollectionBuccal, {});

export const CollectionSalivaIcon = styled(CollectionSaliva, {});

export const StyledSamplesInfoByTypeIcon = styled(Box, {
  border: '$borderWidths$1 solid $colors$coolGray300',
  borderRadius: '$6',
  cursor: 'pointer',
  height: `${iconSize}px`,
  marginRight: '$2',
  width: `${iconSize}px`,
  variants: {
    selected: {
      true: {
        border: '$borderWidths$3 solid $colors$darkBlue300',
      },
    },
  },
});

export const StyledSampleTypeText = styled(Box, {
  fontWeight: '$bold',
  variants: {
    selected: {
      true: {
        color: '$darkBlue300',
      },
      false: {
        color: '$darkGray600',
      },
    },
  },
});

export const StyledSalivaOnlyAtHomeText = styled(Box, {
  color: '$darkBlue500',
  fontSize: '$xs',
  lineHeight: '$4',
  textAlign: 'left',
  width: '110px',
});

export const StyledValuePercentageInfoContainer = styled(Box, { display: 'flex', justifyContent: 'space-between' });
